// Moment.js
import moment from "moment";
import "moment/locale/it";
window.moment = moment;

moment.locale('it');